import React, { FC } from "react";
import { CSSTransition } from "react-transition-group";
import type { SimilarFace } from "modules/reactNativeBridge/FacialReactNativeBridge";
import "./SimilarFaceSelection.css";
import styles from "./SimilarFaceSelection.module.scss";

function getDisplayName(face: SimilarFace): string {
  try {
    const userData = JSON.parse(face.userData) as { nickname?: string };
    return userData?.nickname?.trim() || face.personName;
  } catch {
    return face.personName;
  }
}

export interface SimilarFaceSelectionProps {
  isOpen: boolean;
  similarFaces: SimilarFace[];
  onSelect: (face: SimilarFace) => void;
  onCancel: () => void;
  title?: string;
}

export const SimilarFaceSelection: FC<SimilarFaceSelectionProps> = ({
  isOpen,
  similarFaces,
  onSelect,
  onCancel,
  title = "Encontramos mais de uma pessoa similar. Selecione:",
}) => {
  const nodeRef = React.useRef<HTMLDivElement | null>(null);

  if (!isOpen || similarFaces.length < 2) return null;

  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      in={isOpen}
      timeout={400}
      classNames="similar-face-modal"
      nodeRef={nodeRef}
    >
      <div className={styles.overlay} ref={nodeRef}>
        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          <ul className={styles.list}>
            {similarFaces.map((face) => (
              <li key={face.personId} className={styles.item}>
                <button
                  type="button"
                  className={styles.optionButton}
                  onClick={() => onSelect(face)}
                >
                  <span className={styles.personName}>{getDisplayName(face)}</span>
                </button>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onCancel}
          >
            Voltar
          </button>
        </div>
      </div>
    </CSSTransition>
  );
};
